function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeedbackLoopDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 19 35",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.24,0,0,0.24,-1052.93,-601.112)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4425.76,2646.78C4423.23,2646.85 4420.67,2645.88 4418.8,2643.89L4389.72,2613.14C4386.22,2609.43 4386.39,2603.59 4390.09,2600.09C4393.79,2596.6 4399.63,2596.76 4403.13,2600.46L4425.76,2624.4L4448.39,2600.46C4451.89,2596.76 4457.73,2596.6 4461.43,2600.09C4465.13,2603.59 4465.3,2609.43 4461.8,2613.14L4432.72,2643.89C4430.85,2645.88 4428.3,2646.85 4425.76,2646.78Z",
    style: {
      fill: "rgb(212,215,221)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.000132681,0.588863,-0.588863,0.000132681,4425.06,2506.24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-3.616C16.873,-5.4 33.745,-7.351 50.618,-9.211L101.235,-14.855L202.47,-26.142C216.277,-27.681 228.718,-17.736 230.257,-3.929C231.797,9.877 221.852,22.319 208.045,23.858C206.199,24.065 204.245,24.045 202.47,23.858L101.235,12.571L50.618,6.928C33.745,5.068 16.873,3.116 0,1.332C-1.366,1.188 -2.357,-0.037 -2.212,-1.404C-2.087,-2.592 -1.143,-3.496 0,-3.616",
    style: {
      fill: "rgb(212,215,221)",
      fillRule: "nonzero",
      stroke: "rgb(212,215,221)",
      strokeWidth: 1
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackLoopDownArrow);
export default __webpack_public_path__ + "static/media/feedback_loop_down_arrow.75aa112b.svg";
export { ForwardRef as ReactComponent };